export default "{\n    \"heading\": \"¿Eliminar {{assetName}}?\",\n    \"confirmButtonLabel\": \"Eliminar\",\n    \"cancelButtonLabel\": \"Cancelar\"\n}\n"